module.exports = __webpack_public_path__ + "img/final_decision-personal.4dd71205.png";